import { render, staticRenderFns } from "./SeparatorComponent.vue?vue&type=template&id=9b1dc94c&"
import script from "./SeparatorComponent.vue?vue&type=script&lang=js&"
export * from "./SeparatorComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports